module.exports = __webpack_public_path__ + "media/images/writer/monitor/banner-8f4978cef5c456f2f3422951b2d39207.png";